module.exports = __webpack_public_path__ + "87928e816183b91f58a26f7613621480.png";